module.exports = "<img *ngIf=\"imageUrl\" [src]=\"imageUrl\">\n"